import type { FC } from "react";

import { ManageSectionPagesContent } from "./ManageSectionPagesContent";

import { CloseOverlayButton } from "components/materials/sidebar/CloseOverlayButton";
import { ContentSidebarHeader } from "components/materials/sidebar/ContentSidebarHeader";
import { ContentSidebarMain } from "components/materials/sidebar/ContentSidebarMain";
import { OverlayContainer } from "components/materials/sidebar/OverlayContainer";
import { t } from "i18n/i18n";

export const ManageSectionPagesMobilePanel: FC = () => {
  return (
    <OverlayContainer>
      <ContentSidebarHeader panelType="overlay" visibleOnMobile>
        <h3 className="text-black-tint-10">{t("manage_section_pages_modal.title")}</h3>
        <CloseOverlayButton />
      </ContentSidebarHeader>

      <ContentSidebarMain>
        <ManageSectionPagesContent />
      </ContentSidebarMain>
    </OverlayContainer>
  );
};
